/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';

import styles from 'src/shared/app/base/component/data-entry/form/FormikSelectChoice.style';
import messages from 'src/shared/domain/user/l10n/userL10n.json';

import CloseButton from 'src/shared/ui/component/button/CloseButton';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

const useStyles = createUseThemeStyles(styles);

type Props = {
  field: Object,
  onChange: (value: Object) => void,
  children: (value: Object) => React.Node,
  form: Object,
  disabled?: boolean,
};

const FormikSelectChoice = ({
  field,
  onChange,
  form,
  children,
  disabled,
}: Props): React.Node => {
  const classes = useStyles();
  const handleRemoveClick = () => {
    form.setFieldValue(field.name);
    onChange('');
  };
  const intl = useIntl();

  return (
    <div className={classes.selectedItemWrapper}>
      <div className={classes.selectedItem}>{children(field.value)}</div>
      {!disabled && (
        <CloseButton
          onClick={handleRemoveClick}
          ariaLabel={intl.formatMessage(messages.removeUser)}
        />
      )}
    </div>
  );
};

export default React.memo<Props>(FormikSelectChoice);
